import { ChangeDetectionStrategy, Component, OnInit,Input } from "@angular/core";
import { Dialog, SharedModule, DataService } from "@bb-vendure/admin-ui/core";

import { take } from "rxjs";
import { ImportShippingFeeFileDocument } from "src/generated-gql/graphql";
import { AssetFileInputComponent } from "../asset-file-input/asset-file-input.component";

@Component({
  standalone: true,
  imports: [SharedModule, AssetFileInputComponent],
  templateUrl: "./import-file-dialog.component.html",
})
export class ImportFileDiaglogComponent implements Dialog<any>, OnInit {
  resolveWith: (result?: any | undefined) => void;
  ngOnInit(): void {}
  error: string = "";
  fileUpload: File | null = null;

  @Input()
  includeOrderColumn : boolean = false

  constructor() {}

  cancel() {
    this.resolveWith();
  }

 

  handleFileInput(files: File[]) {
    this.fileUpload = files[0] ?? null;
  }

  import(){
    this.resolveWith(this.fileUpload)
  }
}
